module.exports = "/images/mara-av.webp?87b347bbf0a33e07f6b8621b9b4fb865";